module.exports = __webpack_public_path__ + "img/user-illustarator-2.c471359c.png";